// Tipos para configuração do sistema

export interface ApiEndpoints {
  LOGIN: string;
  LOGOUT: string;
  USER_INFO: string;
  REFRESH_TOKEN: string;
  FORGOT_PASSWORD: string;
  RESET_PASSWORD: string;
  CONFIRM_EMAIL: string;
  RESEND_CONFIRMATION: string;
  REGISTER: string;
  CHECKLISTS: string;
  CHECKLIST_BY_ID: string;
  CHECKLIST_ITEMS: string;
  CHECKLIST_ITEM_BY_CHECKLIST: string;
  CHECKLIST_STATS: string;
  CHECKLIST_BY_VEHICLE: string;
  CHECKLIST_ITEMS_DEFAULT: string;
  CHECKLIST_ITEMS_MANAGEMENT: string;
  CHECKLIST_ITEM_BY_ID: string;
  CHECKLIST_ITEMS_STATS: string;
  VEHICLES: string;
  VEHICLE_BY_ID: string;
  DRIVERS: string;
  DRIVER_BY_ID: string;
  USERS: string;
  USER_BY_ID: string;
  PERFIL: string;
  UPLOADS: string;
  UPLOADS_TEST_CONNECTION: string;
  EQUIPMENTS: string;
  EQUIPMENT_BY_ID: string;
  EQUIPMENT_STATS: string;
  CHECKLIST_GROUPS: string;
  CHECKLIST_GROUP_BY_ID: string;
  CHECKLIST_GROUP_STATS: string;
  CHECKLIST_GROUP_BY_TYPE: string;
  CHECKLIST_GROUP_ITEMS: string;
  CHECKLIST_GROUP_ITEM_BY_ID: string;
  CHECKLIST_GROUP_ITEMS_AVAILABLE: string;
  CHECKLIST_GROUP_ITEM_ORDER: string;
  CHECKLIST_GROUPS_BY_ITEM: string;
  SCHEDULES: string;
  SCHEDULE_BY_ID: string;
  DASHBOARD_STATS: string;
  DASHBOARD_EVOLUCAO_CHECKLISTS: string;
  DASHBOARD_ATIVIDADES_RECENTES: string;
  DASHBOARD_VEICULOS_PROBLEMAS: string;
  WHATSAPP_CONNECTIONS: string;
  WHATSAPP_CONNECTION_BY_ID: string;
  WHATSAPP_CONNECT: string;
  WHATSAPP_DISCONNECT: string;
  WHATSAPP_QR_CODE: string;
  WHATSAPP_SEND_MESSAGE: string;
  WHATSAPP_STATUS: string;
  WHATSAPP_INSTANCE_CONNECT: string;
  WHATSAPP_API_KEY: string;
  WHATSAPP_API_KEY_GENERATE: string;
  WHATSAPP_CHATBOT_CONFIG: string;
  WHATSAPP_CHATBOT_RESET: string;
  WHATSAPP_CONTATOS_NAO_IDENTIFICADOS: string;
  WHATSAPP_CONTATOS_NAO_IDENTIFICADOS_STATS: string;
  WHATSAPP_CONTATOS_NAO_IDENTIFICADOS_VINCULAR: string;
  WHATSAPP_CONTATOS_NAO_IDENTIFICADOS_IGNORAR: string;
  WHATSAPP_CONTATOS_NAO_IDENTIFICADOS_MOTORISTAS: string;
  VEHICULO_CHECKLISTS: string;
  VEHICULO_CHECKLIST_BY_ID: string;
  VEHICULO_CHECKLIST_BY_VEHICLE: string;
  VEHICULO_CHECKLIST_JSON: string;
  VEHICULO_CHECKLIST_GROUPS: string;
  VEHICULO_CHECKLIST_ADAPTADO_BY_VEHICLE: string;
  VEHICULO_CHECKLISTS_ADAPTADO: string;
  VEHICULO_CHECKLIST_ADAPTADO_BY_ID: string;
  OCCURRENCES: string;
  OCCURRENCE_BY_ID: string;
  OCCURRENCE_STATISTICS: string;
  OCCURRENCE_RESOLVE: string;
  REPORT_EQUIPMENT_PRODUCTIVITY: string;
  REPORT_CHECKLISTS: string;
  REPORT_VEHICLES: string;
  REPORT_OCCURRENCES: string;
  REPORT_EXPORT_CSV: string;

  // Abastecimentos (Fueling)
  FUELINGS: string;
  FUELING_BY_ID: string;
  FUELING_STATS: string;
  FUELING_IMPORT_CTA_SMART: string;
  FUELING_IMPORTS: string;
  FUELING_IMPORT_BY_ID: string;
  FUELING_VINCULAR_ORFAOS: string;

  // Integrações
  INTEGRATIONS: string;
  INTEGRATION_BY_ID: string;
  INTEGRATION_BY_TYPE: string;
  INTEGRATION_AVAILABLE_FIELDS: string;
  INTEGRATION_TEST: string;
  INTEGRATION_HISTORY: string;

  // Notificações
  NOTIFICATIONS: string;
  NOTIFICATION_BY_ID: string;
  NOTIFICATION_MARK_READ: string;
  NOTIFICATION_MARK_ALL_READ: string;
  NOTIFICATION_UNREAD_COUNT: string;
  NOTIFICATION_TEST: string;

  // Preferências de Tabela do Usuário
  USER_TABLE_PREFERENCES: string;
  USER_TABLE_PREFERENCES_SAVE: string;
  USER_TABLE_PREFERENCES_DELETE: string;

  // Clientes
  CLIENTES: string;
  CLIENTE_BY_ID: string;
  CLIENTE_ETIQUETAS: string;
  CLIENTE_ETIQUETAS_BATCH: string;
  CLIENTES_TESTAR_REGEX: string;

  // Email Connections
  EMAIL_CONNECTIONS: string;
  EMAIL_CONNECTION_BY_ID: string;
  EMAIL_CONNECTION_TEST: string;

  // Dashboard do Cliente
  CLIENT_DASHBOARD_TOKENS: string;
  CLIENT_DASHBOARD_TOKEN_BY_ID: string;
  CLIENT_DASHBOARD_CLIENTE_USUARIOS: string;
  CLIENT_DASHBOARD_USUARIO_BY_ID: string;
}

export interface AuthConfig {
  TOKEN_KEY: string;
  USER_KEY: string;
  TOKEN_EXPIRY_KEY: string;
}

export interface StorageConfig {
  PREFIX: string;
  THEME_KEY: string;
  LANGUAGE_KEY: string;
}

export interface ThemeConfig {
  PRIMARY_COLOR: string;
  SECONDARY_COLOR: string;
  ACCENT_COLOR: string;
  DANGER_COLOR: string;
  SUCCESS_COLOR: string;
  WARNING_COLOR: string;
  INFO_COLOR: string;
}

export interface PaginationConfig {
  DEFAULT_PAGE: number;
  DEFAULT_LIMIT: number;
  MAX_LIMIT: number;
}

export interface TimeoutsConfig {
  API_REQUEST: number;
  TOKEN_REFRESH: number;
  NOTIFICATION: number;
}

export interface EnvironmentConfig {
  IS_DEVELOPMENT: boolean;
  IS_PRODUCTION: boolean;
}

export interface MessagesConfig {
  ERRORS: {
    NETWORK: string;
    SERVER: string;
    UNAUTHORIZED: string;
    FORBIDDEN: string;
    NOT_FOUND: string;
    VALIDATION: string;
    TIMEOUT: string;
  };
  SUCCESS: {
    LOGIN: string;
    LOGOUT: string;
    SAVE: string;
    DELETE: string;
    UPDATE: string;
  };
}

// Importar tipo User de auth para evitar duplicação
export type { User } from './auth';

export interface ConfigType {
  API_BASE_URL: string;
  API_ENDPOINTS: ApiEndpoints;
  AUTH: AuthConfig;
  STORAGE: StorageConfig;
  THEME: ThemeConfig;
  PAGINATION: PaginationConfig;
  TIMEOUTS: TimeoutsConfig;
  ENVIRONMENT: EnvironmentConfig;
  MESSAGES: MessagesConfig;
}

// Interfaces para WhatsApp
export interface WhatsAppConnection {
  id: number;
  nome: string;
  empresa_id: number;
  numero_telefone: string;
  status: 'desconectado' | 'conectando' | 'conectado';
  qr_code?: string;
  ultima_conexao?: string;
  empresa_nome?: string;
  criado_em: string;
  atualizado_em: string;

  // API Key
  api_key?: string;
  instance_name?: string;

  // Novos campos para configurações
  webhook_enabled?: boolean;
  webhook_url?: string;
  webhook_headers?: Record<string, string>;
  webhook_by_events?: boolean;
  webhook_base64?: boolean;
  webhook_events?: string[];
  
  // Campos para perfil
  profile_name?: string;
  profile_status?: string;
  profile_picture_url?: string;
  
  // Configurações de privacidade
  privacy_settings?: {
    readreceipts?: string;
    profile?: string;
    status?: string;
    online?: string;
    last?: string;
    groupadd?: string;
  };
  
  // Configurações gerais
  settings?: {
    rejectCall?: boolean;
    msgCall?: string;
    groupsIgnore?: boolean;
    alwaysOnline?: boolean;
    readMessages?: boolean;
    syncFullHistory?: boolean;
    readStatus?: boolean;
  };
  
  // Presença
  presence?: string;
  
  // Informações adicionais
  business_profile?: Record<string, any>;
  connection_data?: Record<string, any>;
  qr_code_data?: string;

  // Chatbot padrão
  chatbot_enabled?: boolean;
  chatbot_type?: 'default' | 'custom';
  chatbot_messages?: Record<string, string>;
  chatbot_config?: ChatbotConfig;
}

export interface ChatbotConfig {
  sessionTimeoutMinutes?: number;
  maxInvalidAttempts?: number;
  askPhotoOnProblem?: boolean;
  notifyManagerOnNonConformity?: boolean;
  askObservationOnNonConformity?: boolean;
}

export interface ChatbotTemplateInfo {
  key: string;
  label: string;
  description: string;
  variables: string[];
  group: string;
}

export interface WhatsAppConnectionInput {
  nome: string;
  empresa_id: number;
  numero_telefone: string;
}

export interface WhatsAppConnectionUpdate {
  nome?: string;
  numero_telefone?: string;
  api_key?: string;
  instance_name?: string;
  webhook_enabled?: boolean;
  webhook_url?: string;
  webhook_headers?: Record<string, string>;
  webhook_by_events?: boolean;
  webhook_base64?: boolean;
  webhook_events?: string[];
  profile_name?: string;
  profile_status?: string;
  profile_picture_url?: string;
  privacy_settings?: Record<string, any>;
  settings?: Record<string, any>;
  presence?: string;
  business_profile?: Record<string, any>;
  connection_data?: Record<string, any>;
  qr_code_data?: string;
  chatbot_enabled?: boolean;
  chatbot_type?: 'default' | 'custom';
  chatbot_messages?: Record<string, string>;
  chatbot_config?: Record<string, any>;
}

export interface WhatsAppWebhookConfig {
  enabled: boolean;
  url: string;
  headers: Record<string, string>;
  byEvents: boolean;
  base64: boolean;
  events: string[];
}

export interface WhatsAppMessage {
  connection_id: number;
  numero_destino: string;
  mensagem: string;
}

export interface WhatsAppStatus {
  status: string;
  ultima_conexao?: string;
  qr_code_disponivel: boolean;
}

export interface WhatsAppQrCode {
  qr_code: string;
  status: string;
}

// =============================================
// EMAIL CONNECTION TYPES
// =============================================

export interface EmailConnection {
  id: number;
  empresa_id: number;
  nome: string;
  smtp_host: string;
  smtp_port: number;
  smtp_user: string;
  smtp_pass: string;
  smtp_from?: string;
  smtp_from_name?: string;
  smtp_secure: boolean;
  smtp_tls: boolean;
  smtp_require_auth: boolean;
  ativo: boolean;
  criado_por?: number;
  criado_em: string;
  atualizado_em: string;
  empresa_nome?: string;
}

export interface EmailConnectionInput {
  nome: string;
  smtp_host: string;
  smtp_port: number;
  smtp_user: string;
  smtp_pass: string;
  smtp_from?: string;
  smtp_from_name?: string;
  smtp_secure?: boolean;
  smtp_tls?: boolean;
  smtp_require_auth?: boolean;
}

// =============================================
// ENVIO AUTOMÁTICO TYPES
// =============================================

export type TipoEnvio = 'whatsapp' | 'email';
export type FormatoMensagem = 'texto' | 'html';
export type DocumentoTipo = 'cracha_palete' | 'romaneio' | 'mapa_carregamento' | 'etiquetas' | 'resumo' | 'relatorio_paletes_carregados' | 'relatorio_pedidos_volumes_faltantes' | 'relatorio_pedidos_bipados' | 'relatorio_volumes_faltantes';

export interface EnvioAutomaticoConfig {
  id?: number;
  empresa_id?: number;
  agendamento_id?: number;
  operacao_id?: number;
  tipo: TipoEnvio;
  conexao_id: number;
  destinatarios: string[];
  destinatarios_cc?: string[];
  destinatarios_cco?: string[];
  assunto?: string;
  mensagem?: string;
  formato_mensagem?: FormatoMensagem;
  documento: DocumentoTipo;
  ativo?: boolean;
  conexao_nome?: string;
}

export const DOCUMENTO_LABELS: Record<DocumentoTipo, string> = {
  cracha_palete: 'Crachá Palete',
  romaneio: 'Romaneio de Paletes',
  mapa_carregamento: 'Mapa de Carregamento',
  etiquetas: 'Etiquetas de Paletes',
  resumo: 'Resumo da Operação',
  relatorio_paletes_carregados: 'Relatório Paletes Carregados',
  relatorio_pedidos_volumes_faltantes: 'Relatório Pedidos e Volumes Faltantes',
  relatorio_pedidos_bipados: 'Relatório Pedidos Bipados',
  relatorio_volumes_faltantes: 'Relatório Volumes Faltantes'
};
